module.exports = __webpack_public_path__ + "media/images/partner/supporter/profski-8a8f516e65a0b6188c3e16c7a97d6f18.png";